import { createContext } from "react"
const BackdropContext = createContext("backdrop")
export default BackdropContext
